import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import * as React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: '1rem 2rem',
      backgroundColor: theme.palette.background.paper
    }
  });

interface ISubSectionProps extends WithStyles<typeof styles> {}

class SubSection extends React.Component<ISubSectionProps> {
  public render() {
    const { classes } = this.props;
    return <div className={classes.root}>{this.props.children}</div>;
  }
}

export default withStyles(styles)(SubSection);
